import { StyledEngineProvider } from '@mui/material/styles'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import updateLocale from 'dayjs/plugin/updateLocale'
import type { ReactNode } from 'react'
import ThemeProvider from './theme/theme-provider'

dayjs.extend(updateLocale)
// A semana começa na segunda, como a grade da agenda: fim de semana no fim.
dayjs.updateLocale('pt-br', { weekStart: 1 })
dayjs.locale('pt-br')

/*
 * enableCssLayer põe o CSS do MUI na camada `mui`, abaixo de `utilities`:
 * uma classe do Tailwind sempre ganha do estilo padrão do componente.
 */
export function UiProviders({ children }: { children: ReactNode }) {
  return (
    <StyledEngineProvider enableCssLayer>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
          {children}
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
